import styled from 'styled-components'
import Figure from 'react-bootstrap/Figure'
import { CardWrapper as Card } from '../../../components'
import { colors } from '../../../const/theme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HighchartsReact from 'highcharts-react-official'

export const TestResultsHeader = styled.div`
  width: 98%;
  margin: auto;
  box-shadow: 0 1px 10px 0 ${({ theme }) => theme.card.border};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  @media (max-width: 415px) {
    flex-wrap: wrap;
    height: auto;
    width: 95%;
  }
`

export const HeaderImage = styled(Figure)`
  padding: 0;
  margin: 0;
  @media (max-width: 415px) {
    display: none;
  }
`

export const SectionWrapper = styled.div`
  width: 50%;
  margin: 24px 8px;
  @media (max-width: 415px) {
    width: 95%;
  }
`

export const CardWrapper = styled(Card)`
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  padding: 0 12px;
`

export const UserWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: auto;
  width: 50%;
  #sub-header-wrapper {
    width: auto;
  }
`

export const SectionContainer = styled.div`
  display: flex;
  @media (max-width: 415px) {
    flex-direction: column;
  }
`

export const ScoreWrapper = styled.div`
  display: flex;
  border: 1px solid ${colors.lightGrey};
  margin: 12px auto;
  flex-wrap: wrap;
  height: auto;
  width: 100%;
  #sub-header-wrapper {
    width: auto;
  }
  justify-content: space-between;
`

export const Icon = styled(FontAwesomeIcon)`
  margin: 12px 8px;
`

export const PerformanceWrapper = styled.div`
  width: 98%;
  margin: 32px 8px;
  @media (max-width: 415px) {
    width: 95%;
  }
`

export const HighChartUI = styled(HighchartsReact)`
  width: 100%;
`

export const TimeWrapper = styled(Card)`
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  padding: 0 12px;
  #sub-header-wrapper {
    width: auto;
  }
`

export const Separator = styled.div`
  border-left: 2px solid ${colors.lightGrey};
  height: 50px;
  margin: auto;
  @media (max-width: 415px) {
    display: none;
  }
`

export const TimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: auto;
  @media (max-width: 415px) {
    flex-direction: column;
  }
`

export const ResultsWrapper = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
`

export const AnswerSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: auto;
  justify-content: space-evenly;
`
